import script from "./SensorGroupsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SensorGroupsView.vue?vue&type=script&setup=true&lang=ts"

import "./SensorGroupsView.vue?vue&type=style&index=0&id=e3300624&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3300624"]])

export default __exports__